import { nextTick } from 'vue'
import { excludeFalseyValues } from '@lib/collections'
import Router from 'vue-router'
import { Store } from 'pinia'

interface StoreWithAsObject extends Store {
  asObject: Record<string, unknown>
}

export default {
  methods: {
    toQueryParams(router: Router, key: string, value: unknown) {
      nextTick(() => {
        const route = router.currentRoute
        const currentQuery = { ...route.query }
        const newQuery = { ...route.query, [key]: value.toString() }
        const filteredNewQuery = excludeFalseyValues(newQuery)

        if (JSON.stringify(filteredNewQuery) !== JSON.stringify(currentQuery)) {
          router.replace({ query: filteredNewQuery })
        }
      })
    },
    cleanQueryParams(router: Router, store: StoreWithAsObject) {
      const route = router.currentRoute
      const currentQuery = { ...route.query }
      const filteredNewQuery = excludeFalseyValues(store.asObject)

      if (JSON.stringify(filteredNewQuery) !== JSON.stringify(currentQuery)) {
        router.replace({ query: filteredNewQuery })
      }
    },
  },
}
